import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const RequestAdminAccess: React.FC = () => {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    notes: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess(false);

    try {
      const response = await axios.post(`${API_URL}/api/admin-auth/request-access`, formData);

      if (response.data.success) {
        setSuccess(true);
        setFormData({ email: '', fullName: '', notes: '' });
      } else {
        setError(response.data.error || 'Failed to submit request');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to submit access request. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div style={{ maxWidth: '600px', margin: '2rem auto', padding: '2rem', textAlign: 'center' }}>
        <Link to="/" className="sr-only">Return to Alert1 Home</Link>
        <div style={{ padding: '2rem', background: '#d4edda', borderRadius: '8px', color: '#155724' }}>
          <h2>✅ Request Submitted</h2>
          <p>Your admin access request has been submitted successfully.</p>
          <p>A super-user will review your request and you will be notified once a decision is made.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '600px', margin: '2rem auto', padding: '2rem' }}>
      <Link to="/" className="sr-only">Return to Alert1 Home</Link>
      <h1>Request Admin Access</h1>
      <p style={{ color: '#666', marginBottom: '2rem' }}>
        Fill out the form below to request admin access to the Alert1 website management system.
        A super-user will review your request and set up your account if approved.
      </p>

      <form onSubmit={handleSubmit} style={{ background: '#f8f9fa', padding: '2rem', borderRadius: '8px' }}>
        <div style={{ marginBottom: '1.5rem' }}>
          <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
            Email Address *
          </label>
          <input
            type="email"
            id="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
            placeholder="your.email@example.com"
            style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid #ddd' }}
          />
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label htmlFor="fullName" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
            Full Name
          </label>
          <input
            type="text"
            id="fullName"
            value={formData.fullName}
            onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
            placeholder="Your full name"
            style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid #ddd' }}
          />
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label htmlFor="notes" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
            Additional Notes (Optional)
          </label>
          <textarea
            id="notes"
            value={formData.notes}
            onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
            placeholder="Any additional information about why you need admin access..."
            rows={4}
            style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid #ddd', fontFamily: 'inherit' }}
          />
        </div>

        {error && (
          <div style={{ padding: '1rem', background: '#f8d7da', color: '#721c24', borderRadius: '4px', marginBottom: '1rem' }}>
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={submitting || !formData.email}
          style={{
            width: '100%',
            padding: '0.75rem',
            background: submitting ? '#ccc' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '1rem',
            cursor: submitting ? 'not-allowed' : 'pointer',
          }}
        >
          {submitting ? 'Submitting...' : 'Submit Request'}
        </button>
      </form>
    </div>
  );
};

export default RequestAdminAccess;
